export const getGridCardStyle = palette => ({
  '.grid-card': {
    minHeight: 1,
    display: 'flex',
    flexDirection: 'column',
    '& .account-card-content .grid-cell--Name': {
      display: 'flex',
    },
    '& .grid-card__grid-content': {
      minHeight: 1,
      flex: '1 1 auto',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      '& .grid-content': {
        display: 'flex',
        minHeight: 1,
        flexDirection: 'column',
        flex: '1',

        '& .no-data': {
          flex: '1 1 0px',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: `linear-gradient(${palette.neutralQuaternaryAlt} 1px, transparent 1px)`,
          backgroundSize: '100px 46px',
        },
        '&>div': {
          display: 'flex',
          width: '100% !important',
          minHeight: 1,
          flexShrink: '1',
        },
        '&>div .table-container': {
          display: 'flex',
          flexDirection: 'column',
          width: '100% !important',
          alignItems: 'stretch',
        },
        '&>div .table-container .fixed-header': {
          width: '100% !important',
        },
        '&>div .table-container .viewport': {
          display: 'flex',
        },
      },
      '& .scroll-bar-cover': {
        position: 'absolute',
        background: 'white',
      },
      '& .empty-content': {
      },
      '&:hover .scroll-bar-cover': {
        display: 'none',
      },
    },
    '& .grid-links': {
      margin: '10px 0 16px',
    },
    '& .grid-links .view-all-clickLink': {
      flex: '0 0 auto',
    },
    '& table': {
      tableLayout: 'fixed',
    },
    '& table>thead>tr>th': {
      backgroundColor: 'white',
      borderBottom: 'none',
      fontWeight: '600',
    },
    '& table>thead>tr>th:focus': {
      outline: 'none',
    },
    '& table>tbody>tr': {
      height: 43,
    },
    '& table>tbody>tr>td': {
      borderBottom: 'none',
      borderTop: `1px solid ${palette.neutralLighter}`,
      verticalAlign: 'middle',
      padding: '6px',
    },
    '& .grid-cell--Name': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0 5px',
      fontSize: '12px',
      lineHeight: '20px',

      '& a': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        flex: '0 1 auto',
        minWidth: '1px',
      },
      '& .inactive': {
        color: '#797775',
      },
    },
    '& .grid-cell--Name .search-term-detail': {
      fontSize: 11,
      color: '#666666',
    },
    '& .grid-cell--Name .search-term-detail .glyphicon': {
      fontFamily: '"MsAds MDL2 Assets"',
      marginRight: 5,
      position: 'static',
    },
    '& .grid-cell--Name .search-term-detail .actions': {
      display: 'flex',
    },
    '& .grid-cell--Name .search-term-detail .actions button': {
      border: '0',
      boxShadow: 'none',
      borderRadius: '0',
      backgroundColor: 'white',
      color: '#666666',
      padding: '0',
    },
    '& .grid-cell--Name .search-term-detail .actions .add': {
      display: 'flex',
      alignItems: 'center',
      marginRight: 15,
    },
    '& .grid-cell--Name .search-term-detail .actions .add .glyphicon:before': {
      fontFamily: '"MsAds MDL2 Assets"',
      color: '#1570a6',
      content: '"\\E710"',
    },
    '& .grid-cell--Name .search-term-detail .actions .exclude': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .grid-cell--Name .search-term-detail .actions .exclude .glyphicon:before': {
      fontFamily: '"MsAds MDL2 Assets"',
      color: '#d90026',
      content: '"\\E738"',
    },
    '& .grid-cell--Name__hover-container': {
      position: 'absolute',
      display: 'none',
      fontSize: 12,
      color: '#333333',
      width: '0',
      height: '0',
      zIndex: '10',
    },
    '& .grid-cell--Name__hover-container .hover-content': {
      position: 'absolute',
      maxWidth: 300,
      padding: 15,
      borderRadius: 2,
      left: 15,
      bottom: 35,
      boxShadow: '0 3.2px 7.2px 0 rgba(0,0,0,.132), 0 0.6px 1.8px 0 rgba(0,0,0,.108)',
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
      '@supports (backdrop-filter: blur(60px))': {
        backdropFilter: 'blur(60px)',
        backgroundColor: 'rgba(255, 255, 255, 0.25)',
      },
    },
    '& .grid-cell--Name__hover-container .hover-content:hover': {
      display: 'none',
    },
    '& .grid-cell--Name__hover-container .hover-content__text': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .grid-cell--Name__hover-container .hover-content__name': {
      whiteSpace: 'pre',
      display: 'flex',
      flexWrap: 'wrap',
      paddingTop: 15,
    },
    '& .grid-cell--Name__hover-container .hover-content__name .name-value': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& .grid-cell--Name__hover-container .hover-content__title': {
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      wordBreak: 'normal',
      paddingTop: 15,
    },
    '& .grid-cell--Name__hover-container .hover-content__content': {
      overflow: 'hidden',
      height: '0',
      visibility: 'hidden',
      whiteSpace: 'pre',
      margin: '0 5px',
    },
    '& tr:nth-child(2) .grid-cell--Name__hover-container .hover-content, tr:nth-child(3) .grid-cell--Name__hover-container .hover-content': {
      bottom: 'auto',
      top: 5,
    },
    '& .status': {
      display: 'inline-block',
      marginRight: 5,
    },
    '& .grid-card-header': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      minWidth: 1,
      flex: '0 1 auto',
    },
    '& .metric-picker__name': {
      textAlign: 'right',
    },
    '& .metric-picker .dropdown': {
      position: 'absolute',
      zIndex: '1000',
    },
    '& .col-Name': {
      width: '36%',
    },
    '& .performance-metric-col-sorting': {
      width: '30%',
    },
    '& .performance-metric-col-non-sorting': {
      width: '17%',
    },
    '& .performance-metric-td-sorting': {
      backgroundColor: palette.neutralLighter,
    },
    '& .performance-metric-th-sorting-pop': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .performance-metric-th-sorting': {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    '& .grid-card-cell--performance-metric': {
      display: 'flex',
      alignItems: 'center',
    },
    '& .grid-card-cell--performance-metric .grid-card-cell__body': {
      flex: '1',
      marginRight: 10,
      textAlign: 'right',
      fontSize: '12px',
      lineHeight: '20px',
    },
    '& .grid-card-cell--performance-metric .grid-card-cell__extra': {
      flex: '1',
      fontSize: '80%',
    },
    '& .sort-indicator': {
      top: 4,
      marginRight: 5,
    },
    '& .table > thead > tr > th.column-header-sortable': {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: palette.neutralLighter,
      },
      '&:focus': {
        backgroundColor: palette.neutralQuaternaryAlt,
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: '-1px',
      },
      '& .sort-indicator.glyphicon.glyphicon-arrow-down:before': {
        content: '"\\EE69"',
        fontFamily: 'MsAds MDL2 Assets',
      },
      '& .sort-indicator.glyphicon.glyphicon-arrow-up:before': {
        content: '"\\EE68"',
        fontFamily: 'MsAds MDL2 Assets',
      },
      '& button.dropdown-toggle': {
        background: 'transparent',
        '&:hover': {
          backgroundColor: palette.neutralTertiaryAlt,
        },
        '&:focus': {
          backgroundColor: palette.neutralSecondaryAlt,
        },
      },
    },
  },
});
